// Wordmark OpenBackup — texto, no imagen.
//
// Proporciones medidas sobre el logo original:
//   altura de mayuscula / em .... 0.714  (Open Sans)
//   relacion x / mayuscula ...... 0.741
//   ".ar" ....................... 0.80 em, misma linea de base
//   tracking .................... -0.01 em
//
// Los colores salen de variables para que cambien con el tema. Ver el
// bloque de :root / [data-theme="light"] en index.css.
//
//   size    font-size en px. La altura de mayuscula resultante es
//           size * 0.714, y el ancho del wordmark ~6.9 * size.
//   tld     mostrar ".ar".

export default function Wordmark({ size = 38, tld = true, style, ...rest }) {
  return (
    <span
      style={{
        fontFamily: 'var(--brand-font)',
        fontSize: size,
        lineHeight: 1,
        letterSpacing: '-0.01em',
        whiteSpace: 'nowrap',
        ...style,
      }}
      {...rest}
    >
      <span style={{ fontWeight: 400, color: 'var(--brand-blue)' }}>Open</span>
      <span style={{ fontWeight: 700, color: 'var(--brand-orange)' }}>Backup</span>
      {tld && (
        <span style={{ fontWeight: 400, fontSize: '0.8em', color: 'var(--brand-tld)' }}>
          .ar
        </span>
      )}
    </span>
  );
}
